angular.module("jv.Common.Directives.VideoPlayer", [])
	.directive("jvVideoPlayer", [function() {
		return {
			"restrict": "A",
			"replace": true,
			"template": '<div class="playback">'
				+ '<div id="placeholder">'
				+ '<div id="jVideoPlayback">'
				+ '</div>'
				+ '</div>'
				+ '<!-- Need to have the controlBar div has to be (id)Controlbar where id is the one assigned to div which will hold the flash video -->'
				+ '<div id="jVideoPlaybackControlBar" class="jVPlayer-controls">'
				+ '<div class="jVPlayer-top-container">'
				+ '<div class="jVPlayer-progress"></div>'
				+ '<div class="jvPlayer-otherControls">'
				+ '<div class="jVPlayer-play" title="Play/Pause"></div>'
				+ '<div class="jVPlayer-fullScreen"></div>'
				+ '<div class="jVPlayer-volume-control">'
				+ '<div class="jVPlayer-volume" > </div>'
				+ '<div class="jVPlayer-mute" title="Mute/Unmute"></div>'
				+ '</div>'
				+ '<div class="jVPlayer-time">0:00 / 0:00</div>'
				+ '</div>'
				+ '</div>' + '</div>' + '</div>',
			"scope": {
				options: "@options",
				srcs: '=srcs',
				autoplay: '=autoplay'
			},

			"link": function(scope, element, attribute) {
				var options = scope.$eval(scope.options);
				scope.$watch('srcs', function(newValue, oldValue){
					if(angular.isDefined(newValue) && newValue !== null) {
						var options = scope.$eval(scope.options);
						//If oldValue is set and there is a newValue which means the source is being altereed.
						//This needs to be handled differently for flash playback.
                        if (oldValue !== null) {
                          options.changeSrc = true;
                        } else {
                          options.changeSrc = false;
                        }
						options.src = scope.srcs;
						options.newTag = true;
						options.autoplay = scope.autoplay;
						if(angular.isDefined(_gaq)){
							_gaq.push(['_trackEvent', 'Playback', 'CreatePlayer', 'New VideoPlayer Created. ']);	
						}
						$("#placeholder").JVideoPlayer(options);
						$("#placeholder").css("height", options.height + "px");
						$(".playback").css("width", options.width + "px");
						$(".playback").css("height", options.height + "px");
					}
				});
			}
		};
	}]);
